import { env } from "./config/runtimeEnv";

const maxUploadSize = env("REACT_APP_MAX_UPLOAD_SIZE");

export const REACT_APP_SIMULATE_SEND_SMS: boolean = env("REACT_APP_SIMULATE_SEND_SMS") !== "false";
export const REACT_APP_MAX_UPLOAD_SIZE: number = maxUploadSize != null ? parseInt(maxUploadSize) : 3145728;
